import { NpStars } from "src/components/np-design/components/NpStars"

export type NpStarsWithCountProps = {
  stars: number
  count: number
}

export const NpStarsWithCount = ({ stars, count }: NpStarsWithCountProps) => {
  return (
    <div className="flex items-center gap-2" aria-label={`${stars} von 5 Sternen`}>
      <NpStars stars={stars} />
      <div className="text-sm whitespace-nowrap opacity-75">({count})</div>
    </div>
  )
}
